// extracted by mini-css-extract-plugin
module.exports = {"opcoes":"AgendamentoOpcoes_opcoes__3vZAL","botao":"AgendamentoOpcoes_botao__CUFvD"};